import { loadScript, cookie } from '@ifeng/ui_base';
import { formatImage, formatUrl } from 'ThreeTerminal_base/publicMethod';

let ua = {};
let uaMsg = {};

if (typeof window !== 'undefined') {
    ua = navigator.userAgent;
    uaMsg = {
        isWhere: reg => {
            return ua.match(reg);
        },
        weixin: ua.match(/MicroMessenger/gi),
        isWeibo: ua.match(/WeiBo/i),
        QQ: ua.match(/QQ\//),
        isAndroid: ua.match(/android/gi),
        isIos: ua.match(/iphone|ipod/gi),
        isIpad: ua.match(/ipad/gi),
        wxosEdition: () => {
            const reg = /([1-9]?[0-9])_([0-9])/gi;
            const iosarr = reg.exec(ua);

            if (iosarr != null && (this.isIos || this.isIpad) && iosarr.length >= 3) {
                return iosarr[1];
            } else {
                return 0;
            }
        },
    };
}

const platForm = () => {
    if (uaMsg.weixin) {
        return 'wx';
    } else if (uaMsg.QQ) {
        return 'qq';
    } else if (uaMsg.isWeibo) {
        return 'weibo';
    } else {
        return 'unknown';
    }
};

const oToS = p => {
    const arr = [];

    for (const n of Object.keys(p)) {
        if (n === 'kind') {
            arr.push(`${n}=${platForm()}|${p[n]}`);
        } else {
            arr.push(`${n}=${p[n]}`);
        }
    }

    return arr.join('&');
};

const callNewsAPP = (base, params) => {
    const coldCall = document.createElement('img');

    coldCall.src = `http://api.iclient.ifeng.com/shareArticle?type=${params.type}&id=${params.id}`;
    coldCall.id = 'coldImg';
    coldCall.style.display = 'none';
    document.body.appendChild(coldCall);

    setTimeout(() => {
        document.body.removeChild(coldCall);
    }, 500);

    const openPath = `wakeupiOS/${base.openPath || 'ifengnews'}`;
    const download = base.download || 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1367873683475';
    const downloadAd = base.downloadAd || '';
    const ucStopover = base.ucStopover || 'http://p1.ifengimg.com/a/2017/callapp/ucStopover_v1.html?';
    const protocolApi = base.protocolApi || 'comifengnewsclient://call';
    const domainApi = base.domainApi || 'https://i.ifeng.com/';
    let noDown = null;

    if (base.downloadAd && base.download) {
        noDown = true;
    }
    const paramsPath = typeof params === 'object' ? `?${oToS(params)}` : '';

    let url = '';

    if (uaMsg.isIos || uaMsg.isIpad) {
        let urls = '';

        if (ua.indexOf('QQBrowser') > 0) {
            url = protocolApi + paramsPath;
        } else {
            url = `${domainApi}${openPath}/call${paramsPath}`;
            urls = `${domainApi}${openPath}/call?remind=1&${paramsPath}`;
        }
        location.href = url;

        setTimeout(() => {
            location.href = urls;
        });
    } else {
        if (uaMsg.weixin || uaMsg.QQ || uaMsg.isWeibo) {
            url = `${download}&android_scheme=${encodeURIComponent(protocolApi + paramsPath)}`;
        } else if (ua.indexOf('UCBrowser') > 0 || ua.indexOf('U;') > 0) {
            url = ucStopover + protocolApi + paramsPath;
        } else {
            url = protocolApi + paramsPath;
        }

        location.href = url;

        if (document.hasFocus() && noDown) {
            setTimeout(() => {
                location.href = downloadAd;
            }, 150);
        }
    }
};

// 拉起拉活
const handleCallNewsApp = (nodata, docType, aid, toUrl) => {
    // 拉新拉活
    const sharenews_dataApi = 'http://api.iclient.ifeng.com/ipadtestdoc';
    const vampire_dataApi = 'https://api.iclient.ifeng.com/api_vampire_article_detail?gv=5.5.5&doc=1';
    let doc_type = '';
    let g_aid = '';
    let ll = '';

    if (nodata === 'nodata') {
        // 品牌
        doc_type = 'list';
    } else {
        doc_type = docType;

        if (doc_type === 'phvideo') {
            g_aid = 'guid';
            ll = aid;
        } else if (doc_type === 'vampire') {
            g_aid = 'aid';

            doc_type = 'doc';

            ll = `${vampire_dataApi}&aid=${aid}`;
        } else if (doc_type === 'web') {
            ll = aid;
        } else {
            g_aid = 'aid';
            ll = `${sharenews_dataApi}?aid=${aid}`;
        }
    }

    callNewsAPP(
        {
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354553159819', // 应用宝地址
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=2905', // 广告下载地址
            domainApi: 'https://api.iclient.ifeng.com/',
        },
        {
            type: doc_type, // 拉起类型
            kind: 'sf_downopen', // 拉起统计
            ref: encodeURIComponent(location.href), // 端内地址
            id: encodeURIComponent(ll), // 端内地址
        },
    );
};

/**
 * 解析广告信息，返回广告回调方法
 * @param { Object } ad
 */
const handleAd = async ad => {
    let callbackFn = null;

    try {
        if (ad.preload) {
            let list = [];
            let index = 0;

            if (typeof ad.preload === 'string') {
                list = [ad.preload];
            } else {
                list = ad.preload;
            }

            while (list.length > index) {
                const scriptUrl = list[index];

                console.log('load', scriptUrl);

                await loadScript(scriptUrl, { cache: false, reload: false });
                ++index;
            }
        }

        callbackFn = new Function(`return ${ad.callback}`)();
    } catch (error) {
        error.message = `AdError - ${error.message}`;

        console.error(error);
        console.error('AdError - AdData', ad);

        if (window && window.BJ_REPORT) window.BJ_REPORT.report(error, false, 'ad');
    }

    return callbackFn;
};

const getScript = async (url, callback) => {
    await loadScript(url, { cache: false, reload: false });

    if (callback) callback();
};

const getUserid = () => {
    return cookie.get('userid');
};

const getSid = () => {
    return cookie.get('sid');
};

const getParam = (key, search) => {
    const params = search.replace('?', '').split('&');
    let ret = '';

    if (params) {
        for (let i = 0, len = params.length; i < len; i++) {
            const pair = params[i].split('=');

            if (key === pair[0]) {
                ret = pair[1];
            }
        }
    }

    return ret;
};

const getATag = tag => {
    if (!tag) {
        return null;
    }

    if (tag.tagName !== 'A') {
        return getATag(tag.parentElement);
    } else {
        return tag;
    }
};

// 全站渠道标记传递，文章页的任意跳转
const handleTjLink = e => {
    const tag = getATag(e.target);

    if (!tag) return;

    const search = location.search;
    const url = location.href;

    let newUrl = '';

    let inWhitelist = false;
    const whitelist = ['http://dol.deliver.ifeng.com/'];

    for (let i = 0, len = whitelist.length; i < len; i++) {
        if (url.indexOf(whitelist[i]) > -1) {
            inWhitelist = true;
        }
    }
    // 如果当前页面的search中有ch=，当前的a标签后缀添加ch=
    if (search && getParam('ch', search) && !inWhitelist) {
        const curSrc = getParam('ch', search);

        if (url.indexOf('?') > -1) {
            if (getParam('ch', url)) {
                // 有别的引流
                newUrl = url.replace(`ch=${getParam('ch', url)}`, `ch=${curSrc}`);
            } else {
                // 没有别的引流
                newUrl = `${url}&ch=${curSrc}`;
            }
        } else {
            newUrl = `${url}?ch=${curSrc}`;
        }

        window.location.href = newUrl;

        if (event && event.preventDefault) event.preventDefault();
        else window.event.returnValue = false;
    }
};

const transform = num => {
    return {
        MozTransformStyle: num,
        WebkitTransform: num,
        OTransform: num,
        msTransform: num,
        transform: num,
    };
};

/**
 * 格式化播放次数
 * @param {string} playTimes 播放次数
 */
const formatPlayTimes = (playTimes, suffix = '次播放') => {
    let playTimesNum = Number(playTimes);

    if (playTimes > 10000) {
        playTimesNum = `${Math.ceil(playTimesNum / 1000) / 10}万`;
    }

    return `${playTimesNum}${suffix}`;
};

/**
 * 判断是否为数组
 * @param {*} originData
 */
const isArray = originData => {
    return Object.prototype.toString.call(originData) === '[object Array]';
};

/**
 * 判断当前浏览器是否可播放
 */
const canPlay = type => {
    const TEST_VID = document.createElement('video');

    return TEST_VID.canPlayType(type);
};

// 获取屏幕可视区域的宽高
const getClientSize = () => {
    if (window.innerHeight !== undefined) {
        return {
            width: window.innerWidth,
            height: window.innerHeight,
        };
    } else if (document.compatMode === 'CSS1Compat') {
        return {
            width: document.documentElement.clientWidth,
            height: document.documentElement.clientHeight,
        };
    } else {
        return {
            width: document.body.clientWidth,
            height: document.body.clientHeight,
        };
    }
};

/**
 * 处理vivo合作页id前缀
 * @param {String} originId 原加密id
 */
const fixVivoDocId = originId => {
    let fixId = originId;

    while (fixId.length < 20) {
        fixId = `0${fixId}`;
    }

    return `V07${fixId}`;
};

/**
 * 旧评论表情词典
 */
const faceImgList = [
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_1.png',
        title: '微笑',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_2.png',
        title: '大笑',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_3.png',
        title: '坏笑',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_4.png',
        title: '可爱',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_5.png',
        title: '爱心',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_6.png',
        title: '鬼脸',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_7.png',
        title: '亲亲',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_8.png',
        title: '思考',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_9.png',
        title: '发怒',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_10.png',
        title: '雷到了',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_11.png',
        title: '闭嘴',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_12.png',
        title: '不高兴',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_13.png',
        title: '哭泣',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_14.png',
        title: '吃惊',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_15.png',
        title: '冷汗',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_16.png',
        title: '发呆',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_17.png',
        title: '咒骂',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_18.png',
        title: '尴尬',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_19.png',
        title: '呕吐',
    },
    {
        img: '//y0.ifengimg.com/a/2015/1130/face_20.png',
        title: '拜拜',
    },
];

/**
 * 评论组件表情词典
 */

const newFaceImgList = [
    {
        class: 'zhoumei',
        title: '皱眉',
        name: 'frown',
    },
    {
        class: 'sese',
        title: '色色',
        name: 'lechery',
    },
    {
        class: 'kuqi',
        title: '哭泣',
        name: 'cry',
    },
    {
        class: 'ciya',
        title: '龇牙',
        name: 'teethlaugh',
    },
    {
        class: 'jing',
        title: '惊',
        name: 'amaze',
    },
    {
        class: 'yun',
        title: '晕',
        name: 'dizzy',
    },
    {
        class: 'qinqin',
        title: '亲亲',
        name: 'kiss',
    },
    {
        class: 'aoman',
        title: '傲慢',
        name: 'arrogant',
    },
    {
        class: 'huanhu',
        title: '欢呼',
        name: 'cheer',
    },
    {
        class: 'keai',
        title: '可爱',
        name: 'cute',
    },
    {
        class: 'haixiu',
        title: '害羞',
        name: 'shy',
    },
    {
        class: 'wulianku',
        title: '捂脸哭',
        name: 'facepalmcry',
    },
    {
        class: 'shengqi',
        title: '生气',
        name: 'angry',
    },
    {
        class: 'kun',
        title: '困',
        name: 'sleepy',
    },
    {
        class: 'guanzhu',
        title: '求关注',
        name: 'follow',
    },
    {
        class: 'yiwen',
        title: '疑问',
        name: 'doubt',
    },
    {
        class: 'liuhan',
        title: '流汗',
        name: 'sweat',
    },
    {
        class: 'kelian',
        title: '可怜',
        name: 'pathetic',
    },
    {
        class: 'hanxiao',
        title: '憨笑',
        name: 'defaultemoji',
    },
    {
        class: 'outu',
        title: '呕吐',
        name: 'vomit',
    },
    {
        class: 'xiaoku',
        title: '笑哭',
        name: 'laughcry',
    },
    {
        class: 'touxiao',
        title: '偷笑',
        name: 'titter',
    },
    {
        class: 'jianxiao',
        title: '奸笑',
        name: 'comic',
    },
    {
        class: 'zhuakuang',
        title: '抓狂',
        name: 'crazy',
    },
    {
        class: 'shuizhao',
        title: '睡着',
        name: 'sleep',
    },
    {
        class: 'cuoe',
        title: '错愕',
        name: 'astonished',
    },
    {
        class: 'daku',
        title: '大哭',
        name: 'bigcry',
    },
    {
        class: 'leng',
        title: '愣',
        name: 'daze',
    },
    {
        class: 'fendou',
        title: '奋斗',
        name: 'struggle',
    },
    {
        class: 'angel',
        title: '天使',
        name: 'angel',
    },
    {
        class: 'bye',
        title: '拜拜',
        name: 'bye',
    },
    {
        class: 'shuai',
        title: '衰',
        name: 'wane',
    },
    {
        class: 'ganga',
        title: '尴尬',
        name: 'awkward',
    },
    {
        class: 'bizui',
        title: '闭嘴',
        name: 'shutup',
    },
    {
        class: 'sick',
        title: '生病',
        name: 'fallill',
    },
    {
        class: 'love',
        title: '爱心',
        name: 'heart',
    },
    {
        class: 'rose',
        title: '玫瑰',
        name: 'rose',
    },
    {
        class: 'guzhang',
        title: '鼓掌',
        name: 'applause',
    },
    {
        class: 'dianzan',
        title: '点赞',
        name: 'praise',
    },
    {
        class: 'guapi',
        title: '西瓜',
        name: 'watermelon',
    },
];

// 获取链接地址加密id
const getUrlSecretId = (url) => {
    if (url) {
        return url.split('?')[0].split('/').pop();
    } else {
        return url;
    }
};

export {
    callNewsAPP,
    handleCallNewsApp,
    handleAd,
    getScript,
    getUserid,
    getSid,
    handleTjLink,
    transform,
    formatPlayTimes,
    isArray,
    canPlay,
    getClientSize,
    fixVivoDocId,
    faceImgList,
    newFaceImgList,
    getUrlSecretId
};

